import { Binder, BinderPropertyDescriptor, IBinding } from "../../../binding/binding";
import { BindingPrototype } from "../../prototype/bindingPrototype";
import { HtmlBridgePrototype } from "../../prototype/htmlBridgePrototype";
import { View } from "../../../uiPatterns/mvvm/view";
import { ViewModel } from "../../../uiPatterns/mvvm/viewmodel";
import { HtmlBridge } from "../htmlBridge";

export class InnerTextBridgePrototype extends HtmlBridgePrototype{
    createInternal(view: View<ViewModel>, node: Node): HtmlBridge {
        let bridge = new InnerTextBridge(this);
        bridge.create(view,node);
        return bridge;
    }
}

class InnerTextBridge extends HtmlBridge{
    
    private binding:IBinding;
    private element:Element;
    private bindingPrototype : BindingPrototype;
    
    constructor(prototype:InnerTextBridgePrototype) {
        super();
        this.bindingPrototype = prototype.binding;
    }
    
    public set value(v: string) { 
        this._value = v; 
        this.element.textContent=v;
    } public get value(): string { return this._value;} private _value: string;
    
    public create(view:View<any>,node:Node){
        this.element = <Element>node;
        this.binding = this.bindingPrototype.create(view,new BinderPropertyDescriptor(this,'value'));
    }

    public release(){
        this.binding.release();
    }
}